/**
 * Template Registry
 * Defines all available modular templates.
 */

export const templateRegistry = [
  {
    id: 'hybrid_rewards_x',
    path: './hybrid_rewards_x',
    name: 'Hybrid Rewards X',
    category: 'Earning',
    desc: 'Premium crypto-style rewards platform with spin, tasks and charts.',
    tags: ["crypto", "web3", "analytics", "tasks", "spin"],
    preview: 'https://images.unsplash.com/photo-1621761191319-c6fb62004040?q=80&w=2070&auto=format&fit=crop'
  },
  {
    id: 'earnhub',
    path: './earnhub',
    name: 'EarnHub App',
    category: 'Earning',
    desc: 'High performance engagement dashboard with user recruitment grids, chat hubs, and custom channels.',
    tags: ["crypto", "earnhub", "networks", "referrals"],
    preview: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?q=80&w=2070&auto=format&fit=crop'
  },
  {
    id: 'sparkbnb',
    path: './sparkbnb',
    name: 'SparkBNB App',
    category: 'Staking & Rewards',
    desc: 'Gold-and-blue decentralized rewards portal with custom daily claims, ranks leaderboard, and long press administrator portals.',
    tags: ["bnb", "sparkbnb", "staking", "rewards"],
    preview: 'https://images.unsplash.com/photo-1621761191319-c6fb62004040?q=80&w=2070&auto=format&fit=crop'
  },
  {
    id: 'duxbux',
    path: './duxbux',
    name: 'DuxBux Platform',
    category: 'Engagements & Ads',
    desc: 'Carbon dark modern ecosystem featuring check-in streaks, monetag ad injection triggers, and code verification redemptions.',
    tags: ["bux", "duxbux", "ads", "streaks"],
    preview: 'https://images.unsplash.com/photo-1642790106117-e829e14a795f?q=80&w=2070&auto=format&fit=crop'
  }
];

export async function loadTemplate(templateId: string) {
  switch(templateId) {
    case 'hybrid_rewards_x': return import('./hybrid_rewards_x');
    case 'earnhub': return import('./earnhub');
    case 'sparkbnb': return import('./sparkbnb');
    case 'duxbux': return import('./duxbux');
    default: return import('./hybrid_rewards_x');
  }
}
